// Rail truy cập nhanh (UI_SPEC §3.3): Túi · Sự Vụ · Phi Kiếm Truyền Thư, mỗi nút mở trang con.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { openSubpage, railCollapsed, setRailCollapsed, type SubpageId } from '@state/modules/ui';
import { Icon, type IconName } from '../icons';

const ITEMS: readonly { id: SubpageId; icon: IconName; key: string }[] = [
  { id: 'bag', icon: 'bag', key: 'ui.rail.bag' },
  { id: 'tasks', icon: 'tasks', key: 'ui.rail.tasks' },
  { id: 'mail', icon: 'mail', key: 'ui.rail.mail' },
];

export function Rail(): JSX.Element {
  const collapsed = railCollapsed.value;
  return (
    <aside class={collapsed ? 'shell-rail collapsed' : 'shell-rail'} data-id="rail">
      {ITEMS.map((it) => (
        <button
          key={it.id}
          type="button"
          class="rail-btn"
          data-id={`rail-${it.id}`}
          aria-label={t(it.key)}
          tabIndex={collapsed ? -1 : 0}
          onClick={() => openSubpage(it.id)}
        >
          <Icon name={it.icon} />
        </button>
      ))}
      <button
        type="button"
        class="rail-chevron"
        data-id="rail-toggle"
        aria-label={t(collapsed ? 'ui.rail.expand' : 'ui.rail.collapse')}
        aria-expanded={!collapsed}
        onClick={() => setRailCollapsed(!collapsed)}
      >
        <Icon name={collapsed ? 'chevronLeft' : 'chevronRight'} />
      </button>
    </aside>
  );
}
